import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MODELS } from '../../../../../Apis/Models';
//
import { MobileIcon, CancelIconSvg, LaptopIcon } from '../../../../../components/buttons/IconButtons';
import { allowedModuleIdsApp, allowedModuleIdsWeb } from '../Model/AllowedModules';
import CustomAccordion from './../../../../../components/Accordion/CustomAccordion';
import searchVar from './../../../../../utils/SearchVar';
import DraggableBox from './DraggableBox';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 * 
 * @Component
 * @param {Object} props - Component props.
 * @param {Array} props.mobileChooseList - List of selected permissions for the mobile app.
 * @param {Array} props.websiteChooseList - List of selected permissions for the web app.
 * @param {Function} props.onHandler - Callback function triggered when selecting or removing a role.
 * @param {boolean} props.readOnly - If `true`, disables interactions (no editing or removal allowed).
 *
 */
const ChooseRole = ({ mobileChooseList, websiteChooseList, onHandler, readOnly }) => {
    const { t } = useTranslation();
    const [activeParentKey, setActiveParentKey] = useState(null);
    const [activeChildKey, setActiveChildKey] = useState(null);
    // Handles role selection by passing the selected role to the parent handler.
    const handleRoles = (role) => {
        onHandler(role);
    };
    // Toggles the active parent accordion item.
    const handleParentSelect = (eventKey) => {
        setActiveParentKey((prev) => (prev === eventKey ? null : eventKey));
    };
    // Toggles the active child accordion item.
    const handleChildSelect = (eventKey) => {
        setActiveChildKey((prev) => (prev === eventKey ? null : eventKey));
    };
    // Returns the key (name) of a module from its module ID based on the MODELS mapping.
    const getKeyFromModuleId = (moduleId) => {
        return Object.entries(MODELS).find(([, id]) => id === moduleId)?.[0] || '';
    };

    return (
        <>
            <CustomAccordion
                title='mobile_choose'
                header={
                    <span className='accordion-subtitle-roles'>
                        {t('app').toLocaleUpperCase()} <sub>{`(${mobileChooseList?.length})`}</sub>{' '}
                        <img src={MobileIcon} alt='' />
                    </span>
                }
                button={null}
                currentKey='0'
                activeKey={activeParentKey}
                onSelect={handleParentSelect}
            >
                {allowedModuleIdsApp.map((moduleId) => {
                    const filteredRoles = mobileChooseList.filter(
                        (role) => role.moduleId === moduleId && role.isMobileApp,
                    );

                    if (filteredRoles.length === 0) return null;

                    return (
                        <CustomAccordion
                            title={t(getKeyFromModuleId(moduleId))}
                            header={
                                <span className='accordion-item-roles'>{t(getKeyFromModuleId(moduleId)).toUpperCase()}</span>
                            }
                            currentKey={moduleId.toString()}
                            activeKey={activeChildKey}
                            onSelect={handleChildSelect}
                        >
                            {filteredRoles.map((role) => (
                                <DraggableBox
                                    column='Choosed'
                                    type='box'
                                    index={role.id}
                                    className='infoDrop'
                                    selected={role}
                                    check={1}
                                    onClick={() => handleRoles({ selected: role, check: 3 })}
                                >
                                    <span>{t(searchVar(role?.name))}</span>
                                    {!readOnly && <CancelIconSvg/>}
                                </DraggableBox>
                            ))}
                        </CustomAccordion>
                    );
                })}
            </CustomAccordion>

            <CustomAccordion
                title='web_choose'
                header={
                    <span className='accordion-subtitle-roles'>
                        {t('web_app').toLocaleUpperCase()} <sub>{`(${websiteChooseList?.length})`}</sub>{' '}
                        <img src={LaptopIcon} alt='' />
                    </span>
                }
                button={null}
                currentKey='1'
                activeKey={activeParentKey}
                onSelect={handleParentSelect}
            >
                {allowedModuleIdsWeb.map((moduleId) => {
                    const filteredRoles = websiteChooseList.filter((role) => role.moduleId === moduleId);

                    if (filteredRoles.length === 0) return null;

                    return (
                        <CustomAccordion
                            title={t(getKeyFromModuleId(moduleId))}
                            header={
                                <span className='accordion-item-roles'>{t(getKeyFromModuleId(moduleId)).toUpperCase()}</span>
                            }
                            currentKey={moduleId.toString()}
                            activeKey={activeChildKey}
                            onSelect={handleChildSelect}
                        >
                            {filteredRoles.map((role) => (
                                <DraggableBox
                                    column='Choosed'
                                    type='box'
                                    index={role.id}
                                    className='infoDrop'
                                    selected={role}
                                    check={1}
                                    onClick={() => {
                                        if (!readOnly) handleRoles({ selected: role, check: 4 });
                                    }}
                                >
                                    <span>{t(searchVar(role?.name))}</span>
                                    {!readOnly && <CancelIconSvg />}
                                </DraggableBox>
                            ))}
                        </CustomAccordion>
                    );
                })}
            </CustomAccordion>
        </>
    );
};

export default ChooseRole;
